module.exports = __webpack_public_path__ + "static/media/light-motion-constellation-performance-analysis.1e7160f.mp4";